import React, { FC } from 'react';
import { SVGProps } from '@utils';
import { SvgWrapper } from './SvgWrapper';

export const MobileOkButton: FC<SVGProps> = ({ onClick, divClassName }) => (
  <SvgWrapper
    divClassName={divClassName}
    onClick={onClick}
  >
    <svg width="73" height="73" viewBox="0 0 73 73" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_dd_4506_53755)">
        <ellipse cx="36.3488" cy="33.3603" rx="28.3488" ry="28.3603" fill="#3273E1"/>
        <path d="M32.105 42.5229L23.7012 33.7892L25.3144 32.1126L32.105 39.1698L46.5115 24.1978L48.1248 25.8743L32.105 42.5229Z" fill="white" fillOpacity="0.97"/>
      </g>
      <defs>
        <filter id="filter0_dd_4506_53755" x="0" y="0" width="72.6973" height="72.7207" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset/>
          <feGaussianBlur stdDeviation="0.5"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0"/>
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4506_53755"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
          <feOffset dy="3"/>
          <feGaussianBlur stdDeviation="4"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.16 0"/>
          <feBlend mode="normal" in2="effect1_dropShadow_4506_53755" result="effect2_dropShadow_4506_53755"/>
          <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_4506_53755" result="shape"/>
        </filter>
      </defs>
    </svg>


  </SvgWrapper>
);
